import { Stake, BetType, BetField, BetTable, BetTypeInfo } from "./BetStake"
import { Constants } from "@core/Utils/Constants"
import { deepCopy, numToColor } from "@core/Utils/HelperFunction"
import { Language, Messages } from "@core/GUI/Language"
import { MESSAGE_SEVERITY_LEVEL } from "@core/GUI/Dialogs/MessageController"
import { Client } from "@core/Client"
import { PlayboardMode } from "./Links/IMAXA/IMAXAProtocol"

export enum PresetType{
    BIG_SERIES = "BigSeries",
    NASSA = "NassaBet",
    ORPHANS = "Orphans",
    SERIE_58 = "Serie58",
    ZERO = "ZeroGame"
}

export enum BetCompatibility {
	NONE,
	BOARD,
	TRACK,
	BOTH
};

export enum WinType {
	NORMAL = 1,
	BIG = 2,
	MEGA = 3,
	EPIC = 4,
	JACKPOT = 5
}

export class Bets extends BetTable {
	public selectedStake: number;
	public betTypes: BetTypeInfo[];
	public stakes: Stake[];
	public maxBet:number = 0;

	public FieldLimitsEnabled: boolean;
	public MinimumFieldLimitsEnabled: boolean;

	private Numbers: number[];
	private currentTableMaxWinCredits: number;
	private BLACK_NUM = 0;
	private RED_NUM = 1;
	private GREEN_NUM = 3;

	constructor() {
		super();

		this.betTypes = deepCopy(Client.logic.setup.BetTypes);
		this.stakes = Client.logic.setup.Stakes;
		this.selectedStake = Client.logic.setup.SelectedStake == -1 ? 0 : Client.logic.setup.SelectedStake;
		this.maxBet = Client.logic.setup.MaxBet;

		this.EnableBetLimits();
		this.EnableMinimumBetLimits();

		this.currentTableMaxWinCredits = 0;

		this.Numbers = new Array(38);

		/** number positions */
		if (this.doubleZero) {  //double zero
			this.Numbers[0] = 37;//dblzero
			this.Numbers[1] = 27;
			this.Numbers[2] = 10;
			this.Numbers[3] = 25;
			this.Numbers[4] = 29;
			this.Numbers[5] = 12;
			this.Numbers[6] = 8;
			this.Numbers[7] = 19;
			this.Numbers[8] = 31;
			this.Numbers[9] = 18;
			this.Numbers[10] = 6;
			this.Numbers[11] = 21;
			this.Numbers[12] = 33;
			this.Numbers[13] = 16;
			this.Numbers[14] = 4;
			this.Numbers[15] = 23;
			this.Numbers[16] = 35;
			this.Numbers[17] = 14;
			this.Numbers[18] = 2;
			this.Numbers[19] = 0;
			this.Numbers[20] = 28;
			this.Numbers[21] = 9;
			this.Numbers[22] = 26;
			this.Numbers[23] = 30;
			this.Numbers[24] = 11;
			this.Numbers[25] = 7;
			this.Numbers[26] = 20;
			this.Numbers[27] = 32;
			this.Numbers[28] = 17;
			this.Numbers[29] = 5;
			this.Numbers[30] = 22;
			this.Numbers[31] = 34;
			this.Numbers[32] = 15;
			this.Numbers[33] = 3;
			this.Numbers[34] = 24;
			this.Numbers[35] = 36;
			this.Numbers[36] = 13;
			this.Numbers[37] = 1;
		}
		else {	//single zero
			this.Numbers[0] = 0;
			this.Numbers[1] = 32;
			this.Numbers[2] = 15;
			this.Numbers[3] = 19;
			this.Numbers[4] = 4;
			this.Numbers[5] = 21;
			this.Numbers[6] = 2;
			this.Numbers[7] = 25;
			this.Numbers[8] = 17;
			this.Numbers[9] = 34;
			this.Numbers[10] = 6;
			this.Numbers[11] = 27;
			this.Numbers[12] = 13;
			this.Numbers[13] = 36;
			this.Numbers[14] = 11;
			this.Numbers[15] = 30;
			this.Numbers[16] = 8;
			this.Numbers[17] = 23;
			this.Numbers[18] = 10;
			this.Numbers[19] = 5;
			this.Numbers[20] = 24;
			this.Numbers[21] = 16;
			this.Numbers[22] = 33;
			this.Numbers[23] = 1;
			this.Numbers[24] = 20;
			this.Numbers[25] = 14;
			this.Numbers[26] = 31;
			this.Numbers[27] = 9;
			this.Numbers[28] = 22;
			this.Numbers[29] = 18;
			this.Numbers[30] = 29;
			this.Numbers[31] = 7;
			this.Numbers[32] = 28;
			this.Numbers[33] = 12;
			this.Numbers[34] = 35;
			this.Numbers[35] = 3;
			this.Numbers[36] = 26;
			this.Numbers[37] = -1;
		}

		this.ClearAllBets()
	}

	/**
	* Check bet visibility between track and board if switching is allowed - HiddenCredit is ignored in all compatibility checks, they 
	* represent special side bet presets and are just used for limit calculations
	* @return - 0-not compatible with none(this should never be); 1-board compatible; 2-track compatible; 3-board and track compatible
	*/
	CheckBetsBoardCompatibility(customBetsTable?:  { visible: number, hidden: number }[][]): BetCompatibility {
		let TrackCompatible = true
		let BoardCompatible = true
		this.forEveryPosition((field: BetField, x: number, y: number) => {
			let creditOnThisField = customBetsTable ? customBetsTable[x][y].visible : field.BetCredit
			if (y > 8 && creditOnThisField > 0 && field.Info.Type != BetType.BET_TAUTVA && field.Info.Type != BetType.BET_FIGURE)
				BoardCompatible = false;

			if (y <= 8 && creditOnThisField > 0 && field.Info.Type != BetType.BET_PLAIN && field.Info.Type != BetType.BET_TAUTVA && field.Info.Type != BetType.BET_FIGURE)
				TrackCompatible = false;
		});
		if (BoardCompatible && TrackCompatible) {
			return BetCompatibility.BOTH
		} else if (BoardCompatible) {
			return BetCompatibility.BOARD
		} else if (TrackCompatible) {
			return BetCompatibility.TRACK
		} else {
			return BetCompatibility.NONE
		}
	}

	Calculate(winNum: number): number {
		let TotalWin = this.calculateWins(winNum, false);
		console.log("Total win: " + TotalWin)
		return TotalWin
	}

	Count(ignoreHiddenCredits: boolean = false, ignoreFigures: boolean = false): number {
		let c = 0
		this.forEveryPosition((field: BetField, x: number, y: number) => {
			if (this.checkBet(x, y)) {
				if (field.Info.Type != BetType.BET_FIGURE || (field.Info.Type == BetType.BET_FIGURE && !ignoreFigures))
					c += field.BetCredit

				if (!ignoreHiddenCredits)
					c += field.HiddenCredit
			}
		});
		return c
	}

	CountFromGivenBetArray(_bets: { visible: number, hidden: number }[][]): number {
		let c = 0
		for (let x = 0; x < BetTable.BETS_TABLE_MAX_X; x++)
			for (let y = 0; y < BetTable.BETS_TABLE_MAX_Y; y++)
				c += (_bets[x][y].visible + _bets[x][y].hidden)
		return c;
	}

	CountChipsOnPlayboard(ignoreTautVa: boolean = false): number {
		let res = 0
		this.forEveryPosition((field: BetField) => {
			if (((field.Info.Type == BetType.BET_TAUTVA && !ignoreTautVa) || field.Info.Type != BetType.BET_TAUTVA)  && (field.BetCredit > 0 || field.HiddenCredit > 0))//presets are counted AS IF placed on board ! thats the yserver law
				res++;
		});

		return res
	}

	FindNumberIndex(x: number, y: number): number {
		let Number = this.GetNumberFromXY(x, y);
		if (Number < 0 || Number > 37)
			return -1;

		for (let i = 0; i < 38; i++)
			if (this.Numbers[i] == Number)
				return i;
		return -1;
	}

	GetNumberByIndex(i: number): number {
		/* ce smo prekoracili se vrtimo v krogu */
		let ix = -1; //mora biti zacasna!!!
		if (i < 0)
			ix = (this.doubleZero ? 38 : 37) + i;
		else if (i >= (this.doubleZero ? 38 : 37))
			ix = i - (this.doubleZero ? 38 : 37);
		else
			ix = i;
		return this.Numbers[ix];
	}

	//====================================================================================================
	isZero(vector: { x: number, y: number }): boolean {
		return ((Client.logic.IsDoubleZero && vector.x == 0 && vector.y == 5) || (vector.x == 0 && vector.y == 3));
	}

	coordOfPlainNumber(num: number): { x: number, y: number } {
		if (Client.logic.IsDoubleZero && num > 37 || num > 36)
			return { x: 0, y: 0 };

		if (num == 0)
			if (Client.logic.IsDoubleZero)
				return { x: 0, y: 5 }
			else
				return { x: 0, y: 3 }

		if (num == 37)
			return { x: 0, y: 1 }

		let triade: number = (num - 1) / 3;
		let x: number = 2 + 2 * triade;
		let y: number = 1 + 2 * (3 * (triade + 1) - num);
		return { x, y };
	}

	coordOfBoardCaval(num1: number, num2: number): { x: number, y: number } {
		if (num1 == num2)
			return { x: 0, y: 0 };

		let coord1: { x: number, y: number } = this.coordOfPlainNumber(num1);
		let coord2: { x: number, y: number } = this.coordOfPlainNumber(num2);

		if (this.isZero(coord1) || this.isZero(coord2))
			return { x: 0, y: 0 };

		let toNext = { x: (coord2.x - coord1.x), y: (coord2.y - coord1.y) };

		if (this.isZero(toNext))
			return { x: 0, y: 0 };

		if ((toNext.x + toNext.y) % 2)
			return { x: 0, y: 0 };

		return { x: coord1.x + toNext.x / 2, y: coord2.x + toNext.y / 2 };
	}

	coordOfCorner(numbers:Array<{x:number,y:number}>): { x: number, y: number } {
		if (numbers.length != 4)
			return { x: 0, y: 0 };

		let totalCoord: { x, y } = { x: 0, y: 0 };

		numbers.forEach(number => {
			totalCoord.x += number.x;
			totalCoord.y += number.y;
		});

		if(totalCoord.x % 4 || totalCoord.y % 4)
			return { x: 0, y: 0 };

		return { x: totalCoord.x / 4, y: totalCoord.y / 4 };
	}
	//====================================================================================================

	/**
	 *  TEST THE FLOATS
	 * */
	// this is crazy -dan
	
	GetNumberFromXY(x: number, y: number): number {
		if (0 == x && 1 == y)
			return 37;
		else if (0 == x && (3 == y || 5 == y))
			return 0;
		else
			return (((7 - y) / 2 | 0) + (((x / 2 | 0) - 1) * 3));
	}

	CheckPlayboardLimits(field: BetField, BetCredit: number): number {
		if (!this.FieldLimitsEnabled) {
			console.log("The table is limitless!")
			return BetCredit
		}

		if (this.CountChipsOnPlayboard() + ((0 == field.BetCredit ? 1 : 0)) > this.getStake().BetsCountMax && this.getStake().BetsCountMax > 0) {
			console.log("Cannot place the chip: Max number of chips on the table reached!")
			Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, Language.Get(Messages.MAX_NUM_CHIPS_REACHED), MESSAGE_SEVERITY_LEVEL.NOTICE)
			Client.logic.AreBetsAllowedByLimits = false;
			return 0;
		}

		let BetsNow = this.Count();

		if (this.getStake().PlayBoardLimitMax > 0) {
			BetCredit = Math.min(BetCredit, this.getStake().PlayBoardLimitMax - BetsNow);
			if (BetCredit == 0) {
				console.log("Playboard limit reached!")
				Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, Language.Get(Messages.PLAYBOARD_LIMIT_REACHED), MESSAGE_SEVERITY_LEVEL.NOTICE)
				Client.logic.AreBetsAllowedByLimits = false;
				return 0;
			}
		}

		if (this.maxBet > 0) {
			BetCredit = Math.min(BetCredit, this.maxBet - BetsNow);
			if (BetCredit == 0) {
				console.log("Max bet limit reached!")
				Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, Language.Get(Messages.MAX_BET_LIMIT_REACHED), MESSAGE_SEVERITY_LEVEL.NOTICE)
				Client.logic.AreBetsAllowedByLimits = false;
				return 0;
			}
		}

		if (this.getStake().MaxTableWinLimit > 0) {
			let perNumberWins:number[] = [];
			for (let i = 0; i < field.Info.CoveredNumbers.length; i++) {
				perNumberWins.push(this.calculateWins(field.Info.CoveredNumbers[i], true));
			}
			perNumberWins.sort((a, b) => b - a);
			BetCredit = Math.min(Math.floor((this.getStake().MaxTableWinLimit - perNumberWins[0]) / this.betTypes[field.Info.Type].Multiplier), BetCredit);
			if (BetCredit == 0) {
				console.log("Max win limit reached!")
				Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, Language.Get(Messages.MAX_WIN_LIMIT_REACHED), MESSAGE_SEVERITY_LEVEL.NOTICE)
				Client.logic.AreBetsAllowedByLimits = false;
			}
		}

		return BetCredit;
	}

	GetMinimalLimit(x: number, y: number): number {
		if (!this.MinimumFieldLimitsEnabled || !this.FieldLimitsEnabled || this.getStake().getMinBet(this.getBetType(x, y)) <= 0)
			return 0
		else
			/** TODO: client.VirtualCreditToCredit(this.stake.MinimalsTable[this.getBetType(x,y)]) */
			return this.getStake().getMinBet(this.getBetType(x, y))
	}

	GetMaximalLimit(x: number, y: number): number {
		return Math.max(0, this.getStake().getMaxBet(this.getBetType(x, y)));
	}

	GetNumberXY(num: number, point: { x: number, y: number }): number { // point passed as a reference object
		if ((num < 0) || (num > 37))
			return -1

		point.x = -1
		point.y = -1

		if (0 == num && !this.doubleZero) {
			point.x = 0
			point.y = 3
			return 0
		}
		if (0 == num && this.doubleZero) {
			point.x = 0
			point.y = 5
			return 0
		}
		if (37 == num && this.doubleZero) {
			point.x = 0
			point.y = 1
			return 0
		}

		let ix = 2
		let iy = 1
		for (let i = 1; i <= 36; i++) {
			if (num == i) {
				point.x = ix
				if (iy == 1) point.y = 5
				if (iy == 2) point.y = 3
				if (iy == 3) point.y = 1
				return 0
			}
			if (i % 3 == 0) {
				ix = ix + 2
				iy = 1
			}
			else {
				iy++
			}
		}
		return -1
	}

	clearWins(): void {
		this.forEveryPosition((field: BetField) => {
			field.WonCredit = 0;
		});
	}

	ClearAllBets(userTriggered: boolean = false, ignoreSidebets: boolean = false): void {
		Client.logic.previousBet = 0;

		if (0 == this.Count())
			return;

		Client.game.events.emit(Constants.EVENTS.VIRTUAL_WHEEL_TOGGLE_SPIN_BUTTON, false);

		this.forEveryPosition((field: BetField) => {
			//clear all except tautva bets, those are locked in
			if (field) {
				if (field.Info.Type == BetType.BET_TAUTVA && userTriggered || (field.Info.Type == BetType.BET_FIGURE && field.WonCredit > 0 && ignoreSidebets))
					return;
				field.BetCredit = 0;
				field.WonCredit = 0;
				field.HiddenCredit = 0;
			}
		});
		this.currentTableMaxWinCredits = 0

		//also clear all presets placements in logic , since we wiped hidden credit data
		Client.logic.betPresets.forEach((value, key) => {
			value.bet = 0;
		});

		if (!userTriggered && ignoreSidebets && Client.logic.setup.playboardMode == PlayboardMode.LESFIGURES_PLUS)
			Client.logic.isEmpty = true;

		console.log("All bets were cleaned");
	}

	CalculateTableMaxWinCredits(): number { //izracuna maksimalen možni dobitek glede na trenutno postavitev žetonov
		this.currentTableMaxWinCredits = 0
		for (let winNum = 0; winNum < 38; winNum++) {
			let totalWinForNumber = this.calculateWins(winNum, true)

			if (this.currentTableMaxWinCredits < totalWinForNumber)
				this.currentTableMaxWinCredits = totalWinForNumber
		}//for win numbers
		return this.currentTableMaxWinCredits
	}

	DisableBetLimits(): void {
		this.FieldLimitsEnabled = false
		this.MinimumFieldLimitsEnabled = false
	}

	EnableBetLimits(): void {
		this.FieldLimitsEnabled = true
		this.MinimumFieldLimitsEnabled = true
	}

	DisableMinimumBetLimits(): void {
		this.MinimumFieldLimitsEnabled = false
	}

	EnableMinimumBetLimits(): void {
		this.MinimumFieldLimitsEnabled = true
	}

	calculateWins(winNumber: number, simulate: boolean): number {
		let WinDisplayText: Array<string> = new Array<string>();

		let totalWin = 0;
		let allLimits = 0;

		this.forEveryPosition((field: BetField, x: number, y: number) => {
			if (field && field.Info.Type != BetType.BET_NONE) {
				if (field.BetCredit > 0 || field.HiddenCredit > 0) {
					allLimits += this.GetMaximalLimit(x, y);
				}

				if (field.Info.CoveredNumbers.includes(winNumber)) {
					let winOnThisField = (field.BetCredit + field.HiddenCredit) * this.betTypes[field.Info.Type].Multiplier;
					if (simulate) {
						field.SimulateWinCredit = winOnThisField;
						field.SimulateBetMoney = (field.BetCredit + field.HiddenCredit) / (this.betTypes[BetType.BET_PLAIN].Multiplier / this.betTypes[BetType.BET_PLAIN].Multiplier[field.Info.Type])
					} else {
						field.WonCredit = winOnThisField;

						if (winOnThisField > 0) {

							let coveredNumbersString: string = "";
							let valueToShow;

							field.Info.CoveredNumbers.forEach(num => {
								if (coveredNumbersString.length > 0)
									coveredNumbersString += ","
								coveredNumbersString += num
							});

							if (Client.logic.showMoney)
								valueToShow = Language.InternationalNumberFormat.format(Client.logic.BalanceManager.CreditToMoney(winOnThisField))
							else
								valueToShow = winOnThisField;

							switch (field.Info.Type) {
								case BetType.BET_CARRE: //Bet on four neigbur numbers
									WinDisplayText.push("Corner [" + coveredNumbersString + "] - " + valueToShow);
									break;
								case BetType.BET_CAVAL: //Bet on two neighbur numbers
									WinDisplayText.push("Split [" + coveredNumbersString + "] - " + valueToShow);
									break;
								case BetType.BET_COLOR: //Bet on 18 numbers of the same color no zerro
									if (numToColor(winNumber) == this.RED_NUM)
										WinDisplayText.push("Red - " + valueToShow);
									else
										WinDisplayText.push("Black - " + valueToShow);
									break;
								case BetType.BET_FIFTH: //Bet on five neigbur numbers only on double zerro
									WinDisplayText.push("Five numbers [" + coveredNumbersString + "] - " + valueToShow);
								case BetType.BET_HLINE: //Bet on 12 numbers on a horizontal line
									if (winNumber % 3 == 0)
										WinDisplayText.push("Top 2to1 Third - " + valueToShow);
									else if ((winNumber + 1) % 3 == 0)
										WinDisplayText.push("Middle 2to1 Third - " + valueToShow);
									else
										WinDisplayText.push("Bottom 2to1 Third - " + valueToShow);
									break;
								case BetType.BET_ODEVN: //Bet on 18 numbers odds or evens no zerro
									if (winNumber % 2 == 0)
										WinDisplayText.push("Par - " + valueToShow);
									else
										WinDisplayText.push("Impar - " + valueToShow);
									break;
								case BetType.BET_PHALF: //Bet on 18 numbers playboard half 1-18 or 19-36 no zerro
									if (winNumber < 19)
										WinDisplayText.push("1to18 Half - " + valueToShow);
									else
										WinDisplayText.push("19to36 Half - " + valueToShow);
									break;
								case BetType.BET_PLAIN: //Plain bet on 1 number
									WinDisplayText.push("Straight up [" + coveredNumbersString + "] - " + valueToShow);
									break;
								case BetType.BET_SIXTH: //Bet on six neigbur numbers
									WinDisplayText.push("Six numbers [" + coveredNumbersString + "] - " + valueToShow);
									break;
								case BetType.BET_THIRD: //Bet on 12 numbers a third of the play board
									if (winNumber < 13)
										WinDisplayText.push("1st12 Third - " + valueToShow);
									else if (winNumber < 25)
										WinDisplayText.push("2nd12 Third - " + valueToShow);
									else
										WinDisplayText.push("3rd12 Third - " + valueToShow);
									break;
								case BetType.BET_TRASV: //Bet on three neigbur numbers
									WinDisplayText.push("Trio [" + coveredNumbersString + "] - " + valueToShow);
									break;
								case BetType.BET_FIGURE:
									WinDisplayText.push("Figure [" + coveredNumbersString + "] - " + valueToShow);
									break;
								case BetType.BET_TAUTVA:
									WinDisplayText.push("Taut Va [" + coveredNumbersString + "] - " + valueToShow);
									break;
							}
						}
					}

					if (field.Info.Type != BetType.BET_FIGURE)
						totalWin += winOnThisField;//total win is not accounted for figures

				} else {
					if (simulate) {
						field.SimulateWinCredit = 0;
						field.SimulateBetMoney = 0;
					} else {
						field.WonCredit = 0;
					}
				}
			}
		});

		if (!simulate) {
			let totalBet = this.Count(false, true);//total bet is not accounted for figures
			// console.log("win calculating totalBet : "+totalBet);

			if (this.getStake().PlayBoardLimitMax > 0)
				allLimits = Math.min(allLimits, this.getStake().PlayBoardLimitMax);

			//How epic was that win from 0 to 1 ?
			let howEpicWasThatWin = (Math.log(((totalWin / totalBet) / 36) * Constants.BIG_WIN_SENSITIVITY.MULTIPLIER + 1) / Math.log(Constants.BIG_WIN_SENSITIVITY.MULTIPLIER + 1)) * (Math.log((totalBet / allLimits) * Constants.BIG_WIN_SENSITIVITY.LIMIT + 1) / Math.log(Constants.BIG_WIN_SENSITIVITY.LIMIT + 1));

			if (howEpicWasThatWin > Constants.BIG_WIN_LEVELS_THRESHOLDS.EPIC_WIN) {
				Client.game.events.emit(Constants.EVENTS.PLAY_WIN, WinType.EPIC)
			}
			else if (howEpicWasThatWin > Constants.BIG_WIN_LEVELS_THRESHOLDS.MEGA_WIN) {
				Client.game.events.emit(Constants.EVENTS.PLAY_WIN, WinType.MEGA)
			}
			else if (howEpicWasThatWin > Constants.BIG_WIN_LEVELS_THRESHOLDS.BIG_WIN) {
				Client.game.events.emit(Constants.EVENTS.PLAY_WIN, WinType.BIG)
			}
			else if (totalWin > 0) {
				Client.game.events.emit(Constants.EVENTS.PLAY_WIN, WinType.NORMAL)
			}

			if (totalWin > 0)
				Client.game.events.emit(Constants.EVENTS.UPDATE_MAIN_TEXT, WinDisplayText);
		}

		return totalWin;
	}

	public calculateHistoricWinsText(winNumber: number, fields: BetField[][]): any {
		let WinDisplayText: Array<string> = new Array<string>();

		for (let i = 0; i < BetTable.BETS_TABLE_MAX_X; i++) {
			for (let j = 0; j < BetTable.BETS_TABLE_MAX_Y; j++) {

				if (fields[i][j] && fields[i][j].Info.Type != BetType.BET_NONE && fields[i][j].Info.CoveredNumbers.includes(winNumber)) {

					let winOnThisField = (fields[i][j].BetCredit+fields[i][j].HiddenCredit) * this.betTypes[fields[i][j].Info.Type].Multiplier;

					if (winOnThisField > 0) {

						let coveredNumbersString: string = "";
						let valueToShow;

						fields[i][j].Info.CoveredNumbers.forEach(num => {
							if (coveredNumbersString.length > 0)
								coveredNumbersString += ","
							coveredNumbersString += num
						});

						if (Client.logic.showMoney)
							valueToShow = Language.InternationalNumberFormat.format(Client.logic.BalanceManager.CreditToMoney(winOnThisField))
						else
							valueToShow = winOnThisField;

						switch (fields[i][j].Info.Type) {
							case BetType.BET_CARRE: //Bet on four neigbur numbers
								WinDisplayText.push("Corner [" + coveredNumbersString + "] - " + valueToShow);
								break;
							case BetType.BET_CAVAL: //Bet on two neighbur numbers
								WinDisplayText.push("Split [" + coveredNumbersString + "] - " + valueToShow);
								break;
							case BetType.BET_COLOR: //Bet on 18 numbers of the same color no zerro
								if (numToColor(winNumber) == this.RED_NUM)
									WinDisplayText.push("Red - " + valueToShow);
								else
									WinDisplayText.push("Black - " + valueToShow);
								break;
							case BetType.BET_FIFTH: //Bet on five neigbur numbers only on double zerro
								WinDisplayText.push("Five numbers [" + coveredNumbersString + "] - " + valueToShow);
							case BetType.BET_HLINE: //Bet on 12 numbers on a horizontal line
								if (winNumber % 3 == 0)
									WinDisplayText.push("Top 2to1 Third - " + valueToShow);
								else if ((winNumber + 1) % 3 == 0)
									WinDisplayText.push("Middle 2to1 Third - " + valueToShow);
								else
									WinDisplayText.push("Bottom 2to1 Third - " + valueToShow);
								break;
							case BetType.BET_ODEVN: //Bet on 18 numbers odds or evens no zerro
								if (winNumber % 2 == 0)
									WinDisplayText.push("Par - " + valueToShow);
								else
									WinDisplayText.push("Impar - " + valueToShow);
								break;
							case BetType.BET_PHALF: //Bet on 18 numbers playboard half 1-18 or 19-36 no zerro
								if (winNumber < 19)
									WinDisplayText.push("1to18 Half - " + valueToShow);
								else
									WinDisplayText.push("19to36 Half - " + valueToShow);
								break;
							case BetType.BET_PLAIN: //Plain bet on 1 number
								WinDisplayText.push("Straight up [" + coveredNumbersString + "] - " + valueToShow);
								break;
							case BetType.BET_SIXTH: //Bet on six neigbur numbers
								WinDisplayText.push("Six numbers [" + coveredNumbersString + "] - " + valueToShow);
								break;
							case BetType.BET_THIRD: //Bet on 12 numbers a third of the play board
								if (winNumber < 13)
									WinDisplayText.push("1st12 Third - " + valueToShow);
								else if (winNumber < 25)
									WinDisplayText.push("2nd12 Third - " + valueToShow);
								else
									WinDisplayText.push("3rd12 Third - " + valueToShow);
								break;
							case BetType.BET_TRASV: //Bet on three neigbur numbers
								WinDisplayText.push("Trio [" + coveredNumbersString + "] - " + valueToShow);
								break;
							case BetType.BET_FIGURE:
								WinDisplayText.push("Figure [" + coveredNumbersString + "] - " + valueToShow);
								break;
							case BetType.BET_TAUTVA:
								WinDisplayText.push("Taut Va [" + coveredNumbersString + "] - " + valueToShow);
								break;
						}
					}
				}
			}
		}
		return WinDisplayText;
	}

	getWin(x: number, y: number): number {
		if (!this.checkBet(x, y))
			return 0

		return this.Fields[x][y].WonCredit
	}

	//only used with eraser, so we ignore hiddenCredits
	clearBet(x: number, y: number): boolean {
		if (!this.checkBet(x, y)) return false

		if (this.Fields[x][y].BetCredit == 0) return false

		this.Fields[x][y].BetCredit = 0

		if (!Client.logic.AreBetsAllowedByLimits)
			Client.logic.AreBetsAllowedByLimits = true;

		return true;
	}

	getBet(x: number, y: number): number {
		if (!this.checkBet(x, y))
			return 0

		return (this.Fields[x][y].BetCredit + this.Fields[x][y].HiddenCredit)
	}

	getBetType(x: number, y: number): BetType {
		if (!this.checkBet(x, y))
			return BetType.BET_NONE
		return this.Fields[x][y].Info.Type;
	}

	getStake(): Stake {
		return this.stakes[this.selectedStake]
	}

	checkBet(x: number, y: number): boolean {
		if (x < 0 || y < 0 || x > BetTable.BETS_TABLE_MAX_X - 1 || y > BetTable.BETS_TABLE_MAX_Y - 1) {
			return false
		} else if (!this.Fields[x][y]) {
			return false
		} else if (this.Fields[x][y].Info.Type == BetType.BET_NONE) {
			return false
		} else return true
	}
}